/**
 * Идентификатор для vkRetargeting
 */
export const vkPriceListId = (window.app && window.app.vkPriceListId) || 0
